/** Shows which entity issued an invoice (frozen snapshot; no snapshot = old individual activity). */
export default function IssuerBadge({ issuer, testId }) {
  const legacy = !issuer || issuer.legacy;
  const name = legacy ? "Entidade anterior" : (issuer.trade_name || issuer.legal_name);
  return (
    <span
      title={legacy ? "Emitida pela atividade individual anterior (LuxStay Madeira · NIF 257 794 158)" : `${issuer.legal_name} · NIPC ${issuer.nipc || "—"}`}
      className={`text-[10px] px-2 py-0.5 rounded-full uppercase tracking-wider font-semibold border ${
        legacy ? "border-[#a0b2af]/30 text-[#a0b2af]" : "border-[#d4af37]/50 text-[#d4af37]"
      }`}
      data-testid={testId}
    >
      {name}
    </span>
  );
}
